import { api } from './api-client';
import { toQueryString } from './query';
import { ApiResponse, PaginatedResponse, PaginationQuery, Supplier } from '../types/api';

export type SupplierInput = Omit<Supplier, 'id' | 'active'>;
export interface SupplierQuery extends PaginationQuery { active?: boolean; }

export async function listSuppliers(query: SupplierQuery = {}) {
  const response = await api.get<PaginatedResponse<Supplier>>(`/suppliers${toQueryString(query)}`);
  return response.data;
}
export async function createSupplier(input: SupplierInput) {
  const response = await api.post<ApiResponse<Supplier>>('/suppliers', input);
  return response.data.data;
}
export async function getSupplier(id: number) {
  const response = await api.get<ApiResponse<Supplier>>(`/suppliers/${id}`);
  return response.data.data;
}
export async function updateSupplier(id: number, input: Partial<SupplierInput>) {
  const response = await api.patch<ApiResponse<Supplier>>(`/suppliers/${id}`, input);
  return response.data.data;
}
export async function updateSupplierStatus(id: number, active: boolean) {
  const response = await api.patch<ApiResponse<Supplier>>(`/suppliers/${id}/status`, { active });
  return response.data.data;
}
